import { render, staticRenderFns } from "./RetractableSidebar.vue?vue&type=template&id=05e81626&scoped=true&"
import script from "./RetractableSidebar.vue?vue&type=script&lang=ts&"
export * from "./RetractableSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./RetractableSidebar.vue?vue&type=style&index=0&id=05e81626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e81626",
  null
  
)

export default component.exports